import { render, staticRenderFns } from "./ProductOrderFormDialog.vue?vue&type=template&id=959564ac&scoped=true"
import script from "./ProductOrderFormDialog.vue?vue&type=script&lang=js"
export * from "./ProductOrderFormDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductOrderFormDialog.vue?vue&type=style&index=0&id=959564ac&prod&lang=scss&scoped=true"
import style1 from "./ProductOrderFormDialog.vue?vue&type=style&index=1&id=959564ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959564ac",
  null
  
)

export default component.exports